export const DEA_LICENSES_API_ROUTES = {
  get: '/dea-licenses',
  post: '/dea-licenses',
  patch: '/dea-licenses/{id}',
  delete: '/dea-licenses/{id}',
};

export const CDS_LICENSES_API_ROUTES = {
  get: '/cds-licenses',
  post: '/cds-licenses',
  patch: '/cds-licenses/{id}',
  delete: '/cds-licenses/{id}',
};
